
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotional-sale",
      function () {
        return require("private-next-pages/promotional-sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotional-sale"])
      });
    }
  